import {PortableText} from '@portabletext/react'
import {memo} from 'react'
import TextWithIllustration from '~/components/content/TextWithIllustration'
import CollectionLink from '~/components/content/CollectionLink'
import {ABOUT_PAGE_QUERYResult} from '../../../sanity.types'
import AboutText from '~/components/about/Text'

type AboutPageContentProps = {
    elements: NonNullable<NonNullable<ABOUT_PAGE_QUERYResult>['elements']>
}

const AboutPageContent = memo(({elements}: AboutPageContentProps) => {
    if (elements.length === 0) {
        return null
    }

    return elements.map((element) => {
        switch (element._type) {
            case 'textBlock':
                return <AboutText key={element._key} value={element.text ?? []} />
            case 'textWithIllustration':
                return <TextWithIllustration key={element._key} {...element} />
            case 'collectionLink':
                const {ref, ...propsWithoutRef} = element
                return (
                    <CollectionLink
                        key={element._key}
                        {...propsWithoutRef}
                        className="[&>*>h2]:text-2xl"
                    />
                )
            default:
                return null
        }
    })
})

export default AboutPageContent
